module.exports = __webpack_public_path__ + "img/image-7.b67a044a.png";